import { Inject } from '@odinjs/odin';

import { FieldAPI, FormAPI, TextAreaAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';

import BaseController from './BaseController';

interface Mensagem {
  dsMensagem: string;
}

@Controller({ fragment: 'mensagem-modal' })
class MensagemToastController extends BaseController {

  @Inject('field-mensagem')
  private fieldMensagem: FieldAPI;

  @Inject('text-area-mensagem')
  private textArea: TextAreaAPI;

  @Inject('form-mensagem')
  private formMensagem: FormAPI;

  @OnMount({ target: 'form-mensagem' })
  onMountFormMensagem(): void {
    const { dsMensagem } = this.context.getBulkData() as unknown as Mensagem;
    this.fieldMensagem.setData({ dsMensagem: dsMensagem });
    this.formMensagem.setData({ dsMensagem: dsMensagem });
    this.textArea.setValue(dsMensagem);
  }

}

export default MensagemToastController;
